<template>
  <v-container fluid>
    <!--<v-snackbar-->
    <!--  v-model="snackbar"-->
    <!--  :color="snackbarColor"-->
    <!--  :top="true"-->
    <!--  :right="true"-->
    <!--  :timeout="0"-->
    <!--  absolute-->
    <!--  auto-height-->
    <!--  >-->
    <!--  {{ message }}-->
    <!--  <v-btn-->
    <!--    dark-->
    <!--    flat-->
    <!--    @click="snackbar = false"-->
    <!--  >-->
    <!--    CLOSE-->
    <!--  </v-btn>-->
    <!-- </v-snackbar>-->
    <!--  <v-layout class="mt-12">-->
    <!--  <v-flex xs12>-->
    <div :class="paginatedSummary.length === 7 ? 'viewfsummary_box' : 'viewfsummary_box_empty'">
      <v-card-text>
        <v-layout>
          <v-flex xs3>
            <span class="accent--text" style="font-size: 14px; font-weight:700;"> Farmers Summary</span>
          </v-flex>
          <v-spacer>
          </v-spacer>
          <v-flex xs3>
            <v-text-field label="Search" v-model="search">
            </v-text-field>
          </v-flex>
        </v-layout>
        <table class="table">
          <thead class="thead">
          <tr>
            <th scope="col">Org Name</th>
            <th scope="col">Code</th>
            <th scope="col">Number of Farmers</th>
            <th scope="col">Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="stats in filteredList" v-bind:key="stats.organisationCode">
            <td> {{ stats.organisationName }}</td>
            <td> {{ stats.organisationCode }}</td>
            <td> {{ stats.count }}</td>
            <td class="actions">
              <v-btn color="secondary" small :to="`/farmers/summary/${stats.organisationCode}`"> View More</v-btn>
            </td>
          </tr>
          </tbody>
        </table>
      </v-card-text>
      <v-card-actions>
        <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
        <v-spacer></v-spacer>
        <v-pagination
          v-model="page"
          :length="numberOfLinks"
          color="secondary"
                class="accent--text logoutbtn"
        ></v-pagination>
      </v-card-actions>
    </div>
    <!--  </v-flex>-->
    <!--  </v-layout>-->
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'

export default {
	name: 'farmersummary',
	data: function () {
		return {
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			summaries: [],
			totalCount: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedSummary: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			organisationType: '',
			organisationId: ''
		}
	},
	mounted () {
		this.getLoggedInUser()
		this.getSummmaries()
	},
	watch: {
		summaries () {
			this.paginatedSummary = this.paginationMethod(this.summaries, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.summaries.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedSummary = this.paginationMethod(this.summaries, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedSummary
			} else {
				return this.summaries.filter(item => {
					return item.organisationName.includes(this.search.toLowerCase()) || item.organisationCode.includes(this.search.toLowerCase()) || item.count.includes(this.search.toLowerCase())
				})
			}
		}
	},
	methods: {
		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		getSummmaries () {
			const url = config.serverURI + '/upload/cherry/farmer/summary/' + this.organisationId
			axios.get(url)
				.then(response => {
					this.summaries = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		}
	}
}

</script>
<style scoped>
.viewfsummary_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.viewfsummary_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}
</style>
